<template>
  <div>
    <el-form label-width="130px" :model='combinationData' :rules="rules">
      <el-form-item label="组合筛选功能">
        <el-radio-group v-model="combinationData.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if='combinationData.is_open === 1'>
        <el-form-item label="字段" prop="filter_field_ids">
          <el-select filterable class="w-200" v-model='combinationData.filter_field_ids' multiple placeholder='请选择'>
            <el-option
              v-for="item in fields"
              :label='item.field+item.title'
              :value='item.field_id'>
              <span>{{item.field}}{{item.title}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="允许使用绑定权限">
          <el-input class='h-40 fl w-200 m-r-10' v-model="use_auth"></el-input>
          <el-button size="small" class="m-l-10" @click='openUseRultList()'>查找</el-button>
        </el-form-item>
        <el-form-item label="允许配置绑定权限">
          <el-input class='h-40 fl w-200 m-r-10' v-model="build_auth"></el-input>
          <el-button size="small" class="m-l-10" @click='openBuildRultList()'>查找</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!--Todo 引入权限列表组件-->
    <rule-list
      ref="useRuleList"
      @selectRule="selectUseRule"
      :title="title">
    </rule-list>
    <rule-list
      ref="buildRuleList"
      @selectRule="selectBuildRule"
      :title="title">
    </rule-list>
  </div>  
</template>
<style>

</style>
<script>
import ruleList from '../../Common/business/rule.vue'
export default {
  name: 'combinationDataConfig',
  props: {
    // Todo:对好接口后删除测试数据
    combinationData: {
      type: Object,
      default() {
        return {}
      }
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      // Todo 需要父组件- 是否显示组合筛选 组合筛选数据 字段选择列表
      rules: {
        filter_field_ids: [
          { required: true, message: '请选择字段', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // TODO 获取组合筛选可用字段
  },
  methods: {
    openUseRultList() {
      this.$refs.useRuleList.open()
    },
    openBuildRultList() {
      this.$refs.buildRuleList.open()
    },
    selectUseRule(id, _else, title) {
      this.combinationData.use_auth = {
        id: id,
        title: title
      }
    },
    selectBuildRule(id, _else, title) {
      this.combinationData.build_auth = {
        id: id,
        title: title
      }
    }
  },
  computed: {
    use_auth() {
      return this.combinationData.use_auth.title
    },
    build_auth() {
      return this.combinationData.build_auth.title
    }
  },
  components: {
    ruleList
  }
}
</script>



// WEBPACK FOOTER //
// combinationConfig.vue?b4999afc